import {ChangeDetectorRef, Component, Input, NgZone, OnInit, inject, output, ChangeDetectionStrategy} from '@angular/core';
import {Logo} from "src/app/services/applications/application-instance.service";
import {Observable} from "rxjs";
import {ImageService} from "src/app/services/ui/image.service";
import {NgStyle} from '@angular/common';

@Component({
	selector: 'app-application-icon',
	templateUrl: './application-icon.component.html',
	styleUrls: ['./application-icon.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgStyle]
})
export class ApplicationIconComponent implements OnInit {
	protected imageService = inject(ImageService);
	protected changeDetector = inject(ChangeDetectorRef);

	@Input() logo: Logo;
	@Input() width = 20;
	@Input() height = 20;
	@Input() tileWidth = "35px";
	@Input() tileHeight = "35px";
	@Input() fontSize = "0.9rem";
	@Input() cursor: string | undefined;
	@Input() calculateColor = false;
	readonly outputEvent = output<any>();

	ngOnInit(): void {
		if (this.logo.url && !this.logo.backgroundColor && this.calculateColor) {
			this.imageService.computeRGBColor(this.logo.url).subscribe({
				next: value => this.logo.backgroundColor = value[0]
			})
		}
	}
}
